import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { GlobalService } from "src/app/services/global.service";
import * as SecureLS from "secure-ls";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-comment-section",
  templateUrl: "./comment-section.component.html",
  styleUrls: ["./comment-section.component.css"],
})
export class CommentSectionComponent implements OnInit, OnDestroy {
  @Input() comments: any = [];
  @Input() currentTime: any;
  currentComments = [];
  agoDateTime: string;
  textVal = "";
  showError = false;
  loggedInRole: any;
  currentReplyId: any = null;
  initPageNumber = 1;
  totalCounts = null;
  intervalMethod: any;
  private ls = new SecureLS({ encodingType: "aes" });
  constructor(
    private storageService: StorageService,
    private globalService: GlobalService,
    public router: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {
    this.loggedInRole = this.storageService.getRole();
    this.callGetCommentEvery30Sec();
  }

  ngOnInit(): void {
    this.getComments(this.initPageNumber, this.comments);
  }
  callGetCommentEvery30Sec() {
    this.intervalMethod = setInterval(() => {
      this.comments = [];
      this.getComments(this.initPageNumber, this.comments);
    }, 30000);
  }
  addComment() {
    if (this.textVal) {
      this.showError = false;
      let createRequestPayload: any = {
        vendor_id: this.ls.get("vendor_id"),
        user_id: this.ls.get("createdBy"),
        role_id: this.storageService.getRole(),
        class_room_video_details_id: this.router.snapshot.queryParams.key,
        video_time: this.currentTime,
        video_comments: this.textVal,
      };

      if (this.currentReplyId) {
        createRequestPayload = {
          ...createRequestPayload,
          reply_id: this.currentReplyId,
        };
      }

      this.spinner.show();
      this.globalService
        .create("classVideoDetail/add/comments", createRequestPayload)
        .then((data: any) => {
          if (data["status"] === 200) {
            this.textVal = "";
            this.initPageNumber = 1;
            this.comments = [];
            this.getComments(this.initPageNumber, this.comments);
          }
        });
    } else {
      this.showError = true;
    }
  }

  onLoadmore() {
    let initPageNumber = ++this.initPageNumber;
    this.getComments(initPageNumber, this.comments);
  }

  getComments(initPageNumber, comments) {
    // this.spinner.show();
    this.globalService
      .get("classVideoDetail/get/comments", {
        vendor_id: this.ls.get("vendor_id"),
        user_id: this.ls.get("createdBy"),
        role_id: this.storageService.getRole(),
        class_room_video_details_id: this.router.snapshot.queryParams.key,
        page: initPageNumber,
        page_size: "10",
      })
      .then((bmData) => {
        if (bmData["status"] === 200) {
          this.comments = [...comments, ...bmData["content"].rows];
          this.currentComments = bmData["content"].rows;
          this.totalCounts = bmData["content"].count;
          this.currentReplyId = null;
        }
        this.spinner.hide();
      });
  }

  getAgoTime(createdAt) {
    return moment(createdAt).fromNow();
  }

  onReplyComment(comment) {
    this.currentReplyId = comment.id;
  }
  onReplyClose() {
    this.currentReplyId = null;
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalMethod);
  }
}
